/**
 * Error-boundary capture WITHOUT a static @sentry/remix import (perf
 * 2026-09-07). The static import in root.tsx / RouteErrorBoundary put the
 * whole browser SDK (~38 KB compressed) on every page's critical path; now
 * the SDK is a lazy chunk that only loads when a boundary actually renders
 * (and, separately, after hydration via entry.client's idle init).
 */
export function captureBoundaryError(error: unknown, tags?: Record<string, string>): void {
  // Destructured names (not a namespace) so Rollup tree-shakes the chunk.
  void import("@sentry/remix")
    .then(({ captureException, captureRemixErrorBoundaryError }) => {
      if (tags) {
        captureException(error instanceof Error ? error : new Error(String(error)), { tags });
      } else {
        captureRemixErrorBoundaryError(error);
      }
    })
    .catch(() => {
      /* SDK unavailable — nothing to report to */
    });
}
